import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { BootController } from './boot-control';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
const init = () => {
    __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
        .catch(err => { });
};
const ɵ0 = init;
init();
const ɵ1 = () => init();
const boot = BootController.getbootControl().watchReboot().subscribe(ɵ1);
export { ɵ0, ɵ1 };
